import { render } from "./targetSetting.vue?vue&type=template&id=ec544270&ts=true"
import script from "./targetSetting.vue?vue&type=script&lang=ts"
export * from "./targetSetting.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__